import planFeaturesGroupIds from '../constants/plan-features-gruop-ids';

const updateHighlightedFeaturesPosition = (features, highlightedFeatures) => {
  if (!highlightedFeatures?.length) return features;

  const highlightedFeaturesPositionMap = highlightedFeatures
    .sort((a, b) => a.position - b.position)
    .reduce((acc, { name, position }) => {
      if (!position) return acc;
      acc.set(name, position);
      return acc;
    }, new Map());

  if (!highlightedFeaturesPositionMap.size) return features;

  const { highlightedFeaturesMap, regular } = features.reduce(
    (acc, feature) => {
      if (feature.highlighted && highlightedFeaturesPositionMap.has(feature.id)) {
        if (feature.groupId !== planFeaturesGroupIds.CORE) {
          // eslint-disable-next-line no-param-reassign
          feature.groupId = planFeaturesGroupIds.CORE;
        }

        acc.highlightedFeaturesMap.set(feature.id, feature);
      } else {
        acc.regular.push(feature);
      }

      return acc;
    },
    { regular: [], highlightedFeaturesMap: new Map() }
  );

  return Array.from(highlightedFeaturesPositionMap.entries()).reduce((acc, [name, position]) => {
    const feature = highlightedFeaturesMap.get(name);
    if (!feature) return acc; // Skip if highlighted feature is not present in features

    const safeIndex = Math.max(0, Math.min(position, acc.length));
    acc.splice(safeIndex, 0, feature);
    return acc;
  }, regular);
};

export default updateHighlightedFeaturesPosition;
